import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface ExpandableSectionProps {
  preview: React.ReactNode;
  fullContent: React.ReactNode;
  buttonText?: string;
  buttonTextExpanded?: string;
}
export function ExpandableSection({
  preview,
  fullContent,
  buttonText = 'Leer más',
  buttonTextExpanded = 'Leer menos'
}: ExpandableSectionProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  return <div data-id="element-249">
      {preview}

      <AnimatePresence data-id="element-250">
        {isExpanded && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-251">
            {fullContent}
          </motion.div>}
      </AnimatePresence>

      <button onClick={() => setIsExpanded(!isExpanded)} className="mt-4 flex items-center gap-2 text-orange-600 hover:text-orange-700 font-medium transition-colors" data-id="element-252">
        {isExpanded ? buttonTextExpanded : buttonText}
        {isExpanded ? <ChevronUpIcon className="w-5 h-5" data-id="element-253" /> : <ChevronDownIcon className="w-5 h-5" data-id="element-254" />}
      </button>
    </div>;
}